import { CUSTOM_QUESTION_TYPES_ID } from "repoV2/features/CustomQuestions/constants/CustomQuestionsTypes.constants";
import commonStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";

export const custom_questions_helper_props = {
    [CUSTOM_QUESTION_TYPES_ID.PARAGRAPH_TEXT]: {
        classes: {
            helperText: commonStyles.helperText,
            textInput: commonStyles.inputBaseText,
            textAreaInput: commonStyles.inputBaseAreaText,
            container: commonStyles.customQuestionContainer,
            questionInput: commonStyles.customQuestionStyle,
            optionalQuestionInput: commonStyles.customOptionalQuestionStyle,
            inputCustomStyles: commonStyles.inputCustomStyles,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.SHORT_TEXT]: {
        classes: {
            helperText: commonStyles.helperText,
            textInput: commonStyles.inputBaseText,
            container: commonStyles.customQuestionContainer,
            questionInput: commonStyles.customQuestionStyle,
            optionalQuestionInput: commonStyles.customOptionalQuestionStyle,
            inputCustomStyles: commonStyles.inputCustomStyles,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.URL]: {
        classes: {
            helperText: commonStyles.helperText,
            textInput: commonStyles.inputBaseText,
            container: commonStyles.customQuestionContainer,
            questionInput: commonStyles.customQuestionStyle,
            optionalQuestionInput: commonStyles.customOptionalQuestionStyle,
            inputCustomStyles: commonStyles.inputCustomStyles,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.NUMBER]: {
        classes: {
            helperText: commonStyles.helperText,
            textInput: commonStyles.inputBaseText,
            container: commonStyles.customQuestionContainer,
            questionInput: commonStyles.customQuestionStyle,
            optionalQuestionInput: commonStyles.customOptionalQuestionStyle,
            inputCustomStyles: commonStyles.inputCustomStyles,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.INDIAN_STATE]: {
        classes: {
            helperText: commonStyles.inputBaseHelperText,
            textInput: commonStyles.inputBaseText,
            selectContainer: commonStyles.customQuestionSelectContainer,
            questionInput: commonStyles.customQuestionStyle,
            dropdownHelperText: commonStyles.dropdownHelperText,
            placeholderText: commonStyles.placeholderText,
            inputRoot: commonStyles.selectInput,
            listbox: commonStyles.selectMenuStyle,
            otherTextStyle: commonStyles.otherTextStyle,
            dropdownWithOtherTextStyle: commonStyles.dropdownWithOtherTextStyle,
            inputCustomStyles: commonStyles.inputCustomStyles,
            dropdownBorderStyles: commonStyles.dropdownBorderStyles,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.INDIAN_CITY]: {
        classes: {
            helperText: commonStyles.inputBaseHelperText,
            textInput: commonStyles.inputBaseText,
            selectContainer: commonStyles.customQuestionSelectContainer,
            questionInput: commonStyles.customQuestionStyle,
            dropdownHelperText: commonStyles.dropdownHelperText,
            placeholderText: commonStyles.placeholderText,
            inputRoot: commonStyles.selectInput,
            listbox: commonStyles.selectMenuStyle,
            otherTextStyle: commonStyles.otherTextStyle,
            dropdownWithOtherTextStyle: commonStyles.dropdownWithOtherTextStyle,
            inputCustomStyles: commonStyles.inputCustomStyles,
            dropdownBorderStyles: commonStyles.dropdownBorderStyles,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.GENDER]: {
        classes: {
            helperText: commonStyles.inputBaseHelperText,
            textInput: commonStyles.inputBaseText,
            selectContainer: commonStyles.customQuestionSelectContainer,
            questionInput: commonStyles.customQuestionStyle,
            dropdownHelperText: commonStyles.dropdownHelperText,
            placeholderText: commonStyles.placeholderText,
            inputRoot: commonStyles.selectInput,
            listbox: commonStyles.selectMenuStyle,
            otherTextStyle: commonStyles.otherTextStyle,
            dropdownWithOtherTextStyle: commonStyles.dropdownWithOtherTextStyle,
            inputCustomStyles: commonStyles.inputCustomStyles,
            dropdownBorderStyles: commonStyles.dropdownBorderStyles,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.SINGLE_OPTION_SELECT]: {
        classes: {
            helperText: commonStyles.helperText,
            container: commonStyles.customQuestionContainer,
            questionInput: commonStyles.customQuestionStyle,
            optionalQuestionInput: commonStyles.customOptionalQuestionStyle,
            checkboxLabelText: commonStyles.checkboxLabelText,
            rootCheckboxLabel: commonStyles.rootCheckboxLabelStyle,
            radioButtonStyle: commonStyles.radioButtonStyle,
            optionsStyle: commonStyles.optionsContainerStyle,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.MULTI_OPTION_SELECT]: {
        classes: {
            helperText: commonStyles.helperText,
            container: commonStyles.customQuestionContainer,
            questionInput: commonStyles.customQuestionStyle,
            optionalQuestionInput: commonStyles.customOptionalQuestionStyle,
            checkboxLabelText: commonStyles.checkboxLabelText,
            rootCheckboxLabel: commonStyles.rootCheckboxLabelStyle,
            radioButtonStyle: commonStyles.radioButtonStyle,
            optionsStyle: commonStyles.optionsContainerStyle,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.FILE]: {
        classes: {
            helperText: commonStyles.helperText,
            container: commonStyles.customQuestionContainer,
            questionInput: commonStyles.customQuestionStyle,
            optionalQuestionInput: commonStyles.customOptionalQuestionStyle,
        },
    },
    [CUSTOM_QUESTION_TYPES_ID.CALENDAR]: {
        classes: {
            helperText: commonStyles.helperText,
            textInput: commonStyles.inputBaseText,
            container: commonStyles.customQuestionContainer,
            questionInput: commonStyles.customQuestionStyle,
            optionalQuestionInput: commonStyles.customOptionalQuestionStyle,
            inputCustomStyles: commonStyles.inputCustomStyles,
            datePickerStyle: commonStyles.datePickerStyle,
            calendarIconStyle: commonStyles.datePickerIconStyle,
        },
    },
};
